module.exports = __webpack_public_path__ + "img/23.dbca07f.jpg";